import(/* webpackMode: "eager" */ "/home/runner/work/eon-service/eon-service/frontend/apps/eon/src/app/global-error.tsx");
